import React, { Component } from 'react';
import { Field, reduxForm, getFormSyncErrors } from 'redux-form';
import { Grid, Form } from 'semantic-ui-react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as _ from 'lodash';
import classNames from 'classnames';

import { ControlInfoEnum } from 'Common/FieldEnum';
import { InputField } from 'Common/SemanticWrapper';
import { InputMode } from 'Common/FormEnum';
import { normalizePhone, isValidEmail } from 'Common/FormHelper';
import { DISTRICT_INFORMATION_FORM_NAME } from 'Common/FormEnum';
import { TitledCard, ValidationBanner } from 'Components';
import StateDropdown from 'Common/Components/StateDropdown/StateDropdown';
import { Main } from 'Containers';

class DistrictInformationForm extends Component {
  static propTypes = {
    mainProps: PropTypes.object.isRequired,
  };

  renderInformation = (label, person) => {
    return (
        <TitledCard title={label}>
          <Grid className="grid-spacing">
            <Grid.Row columns={2} className={'remove-spacing'}>
              <Grid.Column>
                <Field
                    name={ControlInfoEnum[person + 'Title']}
                    component={InputField}
                    type="text"
                    maxLength={30}
                    label={'Title'}
                />
              </Grid.Column>
              <Grid.Column>
                <Field
                    name={ControlInfoEnum[person + 'Name']}
                    component={InputField}
                    type="text"
                    maxLength={30}
                    label={'Name'}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row columns={2} className={'remove-spacing'}>
              <Grid.Column>
                <Field
                    name={ControlInfoEnum[person + 'Address1']}
                    component={InputField}
                    type="text"
                    maxLength={30}
                    label={'Address 1'}
                />
              </Grid.Column>
              <Grid.Column>
                <Field
                    name={ControlInfoEnum[person + 'Address2']}
                    component={InputField}
                    type="text"
                    maxLength={30}
                    label={'Address 2'}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row className={'remove-spacing'}>
              <Grid.Column width={8}>
                <Field
                    name={ControlInfoEnum[person + 'City']}
                    component={InputField}
                    type="text"
                    maxLength={21}
                    label={'City'}
                />
              </Grid.Column>

              <Grid.Column width={5}>
                <StateDropdown
                    name={ControlInfoEnum[person + 'State']}
                    style={{ zIndex: '999' }}
                />
              </Grid.Column>
              <Grid.Column width={3}>
                <Field
                    name={ControlInfoEnum[person + 'ZipCode']}
                    component={InputField}
                    type="text"
                    maxLength={5}
                    label={'Zip code'}
                    mode={InputMode.Integer}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row className={'remove-spacing'}>
              <Grid.Column>
                <Grid>
                  <Grid.Row columns={2}>
                    <Grid.Column width={10}>
                      <Field
                          name={ControlInfoEnum[person + 'Email']}
                          component={InputField}
                          type="text"
                          maxLength={50}
                          label={'Email Address'}
                      />{' '}
                    </Grid.Column>
                    <Grid.Column width={6}>
                      <Field
                          name={ControlInfoEnum[person + 'Phone']}
                          component={InputField}
                          type="text"
                          label={'Phone Number'}
                          maxLength={14}
                          mode={InputMode.Integer}
                          normalize={normalizePhone}
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </TitledCard>
    );
  };

  render() {
    const { handleSubmit, syncErrors, mainProps, hide } = this.props;

    return (
        <div className={classNames({ hide: hide })}>
          <Main {...mainProps}>
            <ValidationBanner errors={syncErrors} />
            <section className="student-form-component">
              <Form onSubmit={handleSubmit}>
                <TitledCard title={'District Information'}>
                  <Grid className={'grid-spacing'}>
                    <Grid.Row className={'remove-spacing'}>
                      <Grid.Column width={4}>
                        <Field
                            name={ControlInfoEnum.DistrictCode}
                            component={InputField}
                            type="text"
                            maxLength={20}
                            label={'District Code'}
                            disabled={true}
                        />
                      </Grid.Column>
                      <Grid.Column width={8}>
                        <Field
                            name={ControlInfoEnum.DistrictName}
                            component={InputField}
                            type="text"
                            maxLength={30}
                            label={'District Name'}
                            disabled={true}
                        />
                      </Grid.Column>
                      <Grid.Column width={4}>
                        <Field
                            name={ControlInfoEnum.FiscalYear}
                            component={InputField}
                            type="text"
                            maxLength={20}
                            label={'Current Fiscal Year'}
                            disabled={true}
                        />
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row columns={2} className={'remove-spacing'}>
                      <Grid.Column>
                        <Field
                            name={ControlInfoEnum.Address1}
                            component={InputField}
                            type="text"
                            maxLength={30}
                            label={'Address 1'}
                        />
                      </Grid.Column>
                      <Grid.Column>
                        <Field
                            name={ControlInfoEnum.Address2}
                            component={InputField}
                            type="text"
                            maxLength={30}
                            label={'Address 2'}
                        />
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row
                        style={{ paddingBottom: '15px', paddingTop: '0px' }}
                    >
                      <Grid.Column width={8}>
                        <Field
                            name={ControlInfoEnum.City}
                            component={InputField}
                            type="text"
                            maxLength={21}
                            label={'City'}
                        />
                      </Grid.Column>
                      <Grid.Column width={5}>
                        <StateDropdown
                            name={ControlInfoEnum.State}
                            style={{ zIndex: '999' }}
                        />
                      </Grid.Column>
                      <Grid.Column width={3}>
                        <Field
                            name={ControlInfoEnum.ZipCode}
                            component={InputField}
                            type="text"
                            maxLength={5}
                            label={'Zip code'}
                            mode={InputMode.Integer}
                        />
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </TitledCard>

                {this.renderInformation('Director Information', 'Director')}
                {this.renderInformation('Hearing Officer', 'Hearing')}
              </Form>
            </section>
          </Main>
        </div>
    );
  }
}

const validate = (values, props) => {
  const errors = {};
  if (
      values[ControlInfoEnum.ZipCode] &&
      _.trim(values[ControlInfoEnum.ZipCode]).length < 5
  ) {
    errors[ControlInfoEnum.ZipCode] = 'Please enter valid zip code.';
  }
  if (
      values[ControlInfoEnum.DirectorZipCode] &&
      _.trim(values[ControlInfoEnum.DirectorZipCode]).length < 5
  ) {
    errors[ControlInfoEnum.DirectorZipCode] = 'Please enter valid zip code.';
  }
  if (
      values[ControlInfoEnum.HearingZipCode] &&
      _.trim(values[ControlInfoEnum.HearingZipCode]).length < 5
  ) {
    errors[ControlInfoEnum.HearingZipCode] = 'Please enter valid zip code.';
  }
  if (
      values[ControlInfoEnum.DirectorEmail] &&
      _.trim(values[ControlInfoEnum.DirectorEmail]).length > 0 &&
      !isValidEmail(values[ControlInfoEnum.DirectorEmail])
  ) {
    errors[ControlInfoEnum.DirectorEmail] =
        'Please enter a valid email address.';
  }

  if (
      values[ControlInfoEnum.HearingEmail] &&
      _.trim(values[ControlInfoEnum.HearingEmail]).length > 0 &&
      !isValidEmail(values[ControlInfoEnum.HearingEmail])
  ) {
    errors[ControlInfoEnum.HearingEmail] =
        'Please enter a valid email address.';
  }

  if (
      values[ControlInfoEnum.DirectorPhone] &&
      _.trim(values[ControlInfoEnum.DirectorPhone]).length < 14
  ) {
    errors[ControlInfoEnum.DirectorPhone] = 'Please enter a valid number.';
  }
  if (
      values[ControlInfoEnum.HearingPhone] &&
      _.trim(values[ControlInfoEnum.HearingPhone]).length < 14
  ) {
    errors[ControlInfoEnum.HearingPhone] = 'Please enter a valid number.';
  }

  return errors;
};

const mapStateToProps = state => {
  return {
    syncErrors: getFormSyncErrors(DISTRICT_INFORMATION_FORM_NAME)(state),
  };
};

DistrictInformationForm = connect(mapStateToProps)(DistrictInformationForm);

export default reduxForm({
  validate,
  form: DISTRICT_INFORMATION_FORM_NAME,
  destroyOnUnmount: false,
})(DistrictInformationForm);



// WEBPACK FOOTER //
// ./src/pages/controlinformation/components/DistrictInformationForm.js